import { UserRegistrationModal } from 'components/UserRegistrationModal'
import { useState } from 'react'
import { GoPersonAdd } from 'react-icons/go'

import { UserTable } from './UserTable'

export const UserInfoLayout = () => {
  const [isOpenRegistrationModal, setIsOpenRegistrationModal] = useState(false)
  return (
    <div className="mt-8">
      <div className="flex items-center justify-end">
        <button
          type="button"
          onClick={() => setIsOpenRegistrationModal(true)}
          className="h-12 bg-[#4F46E5] hover:opacity-95 rounded-full px-4 flex items-center justify-between cursor-pointer"
        >
          <GoPersonAdd className="w-6 h-6 text-white mr-3" />
          <p className="text-white text-sm">Adicionar Usuários</p>
        </button>
      </div>

      <UserTable />

      {isOpenRegistrationModal && (
        <UserRegistrationModal setIsOpenModal={setIsOpenRegistrationModal} />
      )}
    </div>
  )
}
